export default "__VITE_ASSET__2bc1b82f__"